import { ScoreTriggerEditable } from '@/ui/DTO';
import { t } from '@/ui/i18n/i18n';

export const actionHint = (scoreTrigger?: ScoreTriggerEditable) => {
  switch (scoreTrigger?.operator) {
    case '<':
      return t('issue-template.hint.below', { to: scoreTrigger.to });
    case '>':
      return t('issue-template.hint.above', { from: scoreTrigger.from });
    case 'between':
      return t('issue-template.hint.between', {
        from: scoreTrigger.from,
        to: scoreTrigger.to,
      });
    default:
      return null;
  }
};
